import { lynnConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function LynnPage() {
  return <CityPageTemplate config={lynnConfig} />;
}